import React from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { FindoSpinner } from "@/components/FindoSpinner";

// Instant full-screen confirmation shown the moment a form is submitted, while the server finishes.
export default function SubmitOverlay({ show, payment = false }) {
  const { t } = useLang();
  if (!show) return null;
  return createPortal(
    <div className="fixed inset-0 z-[70] grid place-items-center bg-[#0A1628]/55 backdrop-blur-sm px-6" data-testid="submit-overlay" role="status" aria-live="polite">
      <motion.div initial={{ opacity: 0, y: 14, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: 0.25 }}
        className="w-full max-w-sm bg-white rounded-3xl overflow-hidden shadow-2xl text-center">
        <div className="bg-findo-navy px-6 pt-7 pb-6">
          <motion.div initial={{ scale: 0.5, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 0.08, type: "spring", stiffness: 260, damping: 15 }}
            className="mx-auto h-16 w-16 grid place-items-center rounded-full bg-white/10 text-[#00C896]">
            <CheckCircle2 size={36} />
          </motion.div>
          <p className="mt-4 font-display text-xl font-semibold text-white" data-testid="submit-overlay-title">{t("sub.received")}</p>
        </div>
        <div className="px-6 py-5">
          <p className="text-sm text-slate-600">{t(payment ? "sub.toPayment" : "sub.publishing")}</p>
          <div className="mt-4 flex justify-center"><FindoSpinner size={36} light={false} /></div>
        </div>
      </motion.div>
    </div>,
    document.body,
  );
}
